import Main from './components/Main';
import cookieUtils from 'js-cookie';
import { AllState } from '@/state';
import { helper, Model, register } from 'reaux-dom';
import { API_CODE, DECRYPT_KEY, DEFAULT_LANGUAGE, LOGIN_PAGE } from '@/utils/constant';
import { analyzeAcceptLanguage } from '@/utils';
import { MenuType, State, Tab, Menu } from './type';
import { AdminService, UserService } from '@/services';
import { message } from 'antd';
import { findItemByKey } from './components/Layout/data';
import { SysPermissionTreeVo } from '@/services/type';

export const authBlackList = [LOGIN_PAGE, '/app/bol', '/app/bol-ftl'];

const initialState: State = {
  lang: DEFAULT_LANGUAGE,
  tabItems: [],
  menus: [],
  userInfo: null,
  pagePaths: null,
  isDecrypt: localStorage.getItem(DECRYPT_KEY) ?? undefined,
};

function findUrls(nodes: SysPermissionTreeVo[], result: string[] = []): string[] {
  // 遍历每个节点
  for (const node of nodes) {
    // 如果当前节点的 type 是 2，加入结果
    if (node.type === MenuType.Page && node.url) {
      result.push(node.url);
    }

    // 如果有子节点，则递归查找子节点
    if (node.children && node.children.length > 0) {
      findUrls(node.children, result);
    }
  }

  return result;
}

class ActionHandler extends Model<State, AllState> {
  async onReady() {
    const lang = cookieUtils.get('lang') || analyzeAcceptLanguage(navigator.languages.join(',') || 'zh');
    this.setState({ lang });
    if (!authBlackList.includes(location.pathname)) {
      await Promise.all([this.getUserInfo(), this.getMenu()]);
    } else {
      this.resetState();
    }
  }

  @helper.loading('menu')
  async getMenu() {
    const response = await AdminService.getUserMenuUsingGET();
    if (response.code === API_CODE.SUCCESS) {
      const pagePaths = response.data ? findUrls(response.data) : [];
      const nextMenus = ((response.data ?? []) as Menu[]).concat([
        {
          name: '代下单',
          url: '/customer/list/order-proxy/:id',
          hidden: true,
        },
        {
          name: '整车代下单',
          url: '/customer/list/order-proxy-ftl/:id',
          hidden: true,
        },
        {
          name: '查看 BOL',
          url: '/order/city/bol/:id',
          hidden: true,
        },
        {
          name: '查看整车 BOL',
          url: '/order/ftl/bol/:id',
          hidden: true,
        },
        {
          name: '查看 POD',
          url: '/order/city/pod/:id',
          hidden: true,
        },
        {
          name: '查看整车 POD',
          url: '/order/ftl/pod/:id',
          hidden: true,
        },
        {
          name: '查看其他单据',
          url: '/order/city/delivery-note/:id',
          hidden: true,
        },
        {
          name: '查看其他单据',
          url: '/order/ftl/delivery-note/:id',
          hidden: true,
        },
        {
          name: '报价配置',
          url: '/customer/list/quote-config/:id',
          hidden: true,
        },
        {
          name: '查看 GPS',
          url: '/order/city/gps/:id',
          hidden: true,
        },
      ]);
      this.setState({ menus: nextMenus, pagePaths });
    }
  }

  async logout() {
    void AdminService.LoginOutUsingGET();
    message.success('退登成功', 1, () => {
      localStorage.removeItem('token');
      location.href = LOGIN_PAGE;
    });
  }

  async appendTabItems(tab: Tab) {
    const tabItem = this.state.tabItems.find((_) => _.key === tab.key);
    if (tabItem) {
      this.setState({
        activeTabKey: tab.key,
        tabItems: this.state.tabItems.map((item) => (item.key === tab.key ? tab : item)),
      });
    } else {
      this.setState({ tabItems: this.state.tabItems.concat(tab), activeTabKey: tab.key });
    }
  }

  async deleteTabByUrl(url: string) {
    const index = this.state.tabItems.findIndex((_) => _.key === url);

    const length = this.state.tabItems.length;
    if (index > -1 && length > 1) {
      const nextTabItems = [...this.state.tabItems];
      nextTabItems.splice(index, 1);
      const nextActiveTabKey = index === length - 1 ? nextTabItems?.[index - 1]?.key : nextTabItems?.[index]?.key;
      this.setState({ tabItems: nextTabItems, activeTabKey: nextActiveTabKey });
      this.router.push(nextActiveTabKey as string);
    }
  }

  async getUserInfo() {
    const response = await UserService.detailUserUsingGET();
    if (response.code === API_CODE.SUCCESS) {
      this.setState({ userInfo: response.data });
    }
  }

  async pushTabItem(pathname: string) {
    const searchParams = new URLSearchParams(location.search);
    const tabAddonAfter = searchParams.get('tabAddonAfter') ?? '';
    const tabId = searchParams.get('id') || undefined;
    const tabCopy = searchParams.get('copy') || undefined;
    const menuItem = findItemByKey(this.state.menus ?? [], pathname);
    if (menuItem && menuItem.url) {
      this.appendTabItems({
        label: menuItem.name,
        key: menuItem.url,
        addonAfter: tabAddonAfter,
        id: tabId,
        copy: tabCopy,
      });
    }
  }
}

export const { actions, View } = register(new ActionHandler('main', initialState), Main);
